<script lang="ts">
    import {TEMPLATE} from 'general/constants';

    import Reminder from './reminder/Reminder.svelte';
    import Phone from 'general/icons/Phone.svelte';
    import PhoneForExperiment from 'general/icons/PhoneForExperiment.svelte';
    import Email from 'general/icons/Email.svelte';

    import s from './style.module.css';

    export let label: string;
    export let inputValue: string;
    export let pattern: string | null;
    export let placeholder = '';
    export let type: 'email' | 'text' | 'submit' | 'reset' | 'tel' = 'text';
    export let required = false;
    export let disabled = false;
    export let isVisibleLabel = false;
    export let withIcon = false;
    export let maxlength = 524288;
    export let minlength = 0;
    export let handleInput: (event: Event) => void;
    export let handleChange: (event: Event) => void = null;
    export let handleInvalid: (event: Event) => void = null;
    export let marginBottom: string;
    export let reminder = '';
    export let reminderStatus: 'error';
    export let template = 'circle';

    let isFocused = false;
    $: errorMarginBottom = template === TEMPLATE.SQUARE_PRODUCT && reminder !== '' ? '39px' : null;
    $: isValidationForSquare =
        (template === TEMPLATE.SQUARE ||
            template === TEMPLATE.EXP_SQUARE ||
            template === TEMPLATE.EXP_SQUARE_MOBILE ||
            template === TEMPLATE.SQUARE_GENDER_MOBILE ||
            template === TEMPLATE.IMAGE_MOBILE ||
            template === TEMPLATE.SQUARE_PRODUCT ||
            template === TEMPLATE.SQUARE_MOBILE ||
            template === TEMPLATE.SQUARE_DESKTOP_COMMON ||
            template === TEMPLATE.SQUARE_EXIT_REDESIGN) &&
        reminder !== '';
    const handleFocus = () => (isFocused = true);
    const handleBlur = () => (isFocused = false);
    $: isPhoneIcon =
        (template === TEMPLATE.EXP_SQUARE && type === 'tel') ||
        (template === TEMPLATE.SQUARE_DESKTOP_COMMON && type === 'tel') ||
        (template === TEMPLATE.SQUARE_EXIT &&
            type === 'tel' &&
            !(isFocused || Boolean(inputValue?.length))) ||
        (template === TEMPLATE.SQUARE_EXIT_REDESIGN && type === 'tel');
    $: isCart = template === TEMPLATE.SQUARE_EXIT_CART;
    $: isNewPhoneIcon =
        template === TEMPLATE.EXP_SQUARE ||
        template == TEMPLATE.SQUARE_DESKTOP_COMMON ||
        template === TEMPLATE.SQUARE_EXIT_REDESIGN;
</script>

<div
    class="{s.wrapper} {s[template] || ''} {s[type] || ''}"
    style="margin-bottom: {errorMarginBottom || marginBottom}"
>
    <label class={s.label}>
        {#if isPhoneIcon}
            <div class={s.phoneIcon} role="presentation">
                {#if isNewPhoneIcon}
                    <PhoneForExperiment />
                {:else}
                    <Phone />
                {/if}
            </div>
        {:else if isCart}
            <div
                class={s.emailIcon}
                class:s.hide={isFocused || Boolean(inputValue.length)}
                role="presentation"
            >
                <Email />
            </div>
        {/if}
        <span
            class={s.labelText}
            class:s.visible={isVisibleLabel}
            class:s.raised={isFocused || Boolean(inputValue.length)}>{label}</span
        >
        {#if template === TEMPLATE.EXP_SQUARE}
            <span
                class={s.expPlaceholderText}
                class:raised={isFocused || Boolean(inputValue.length)}>{placeholder}</span
            >
        {/if}
        <input
            class={s.input}
            id={`sv-${type}-input`}
            name={type}
            class:s.withIcon={withIcon}
            class:s.isFocused={isFocused}
            class:s.isValidationForSquare={isValidationForSquare}
            value={inputValue}
            {maxlength}
            {minlength}
            {placeholder}
            {pattern}
            {type}
            {required}
            {disabled}
            on:input={handleInput}
            on:focus={handleFocus}
            on:blur={handleBlur}
            on:change={handleChange}
            on:invalid={handleInvalid}
        />
    </label>
    <slot />
    {#if template === TEMPLATE.CIRCLE}
        <Reminder children={reminder} {reminderStatus} />
    {:else if reminder !== ''}
        <p class={s.error}>{reminder}</p>
    {/if}
</div>
